import { defineMessages } from 'react-intl';

export default defineMessages({
    faDescribeWhatHappened: {
        id: 'fnol.fa.views.what.Please describe what happened',
        defaultMessage: 'Please describe what happened'
    },
    faDescribePropertyDamage: {
        id: 'fnol.fa.views.what.Please describe the loss',
        defaultMessage: 'Please describe the loss'
    },
    faTypeOfClaim: {
        id: 'fnol.fa.views.what.Type of claim',
        defaultMessage: 'Type of claim'
    },
    faLossCategory: {
        id: 'fnol.fa.views.what.Loss Category',
        defaultMessage: 'Loss Category'
    },
    faSelectedBuildings: {
        id: 'fnol.fa.views.properties.Building(s) Selected',
        defaultMessage: 'Building(s) Selected'
    },
    faPropertyDesc: {
        "id": "fnol.fa.views.details.Property Description",
        "defaultMessage": "Property Description"
    },
    faNoBuildings: {
        id: "fnol.fa.views.properties.There are no buildings",
        defaultMessage: "There are no buildings"
    }
});
